var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/home_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26639 3.18745C8.49799 2.58183 7.3909 2.58183 6.6225 3.18745L2.89648 6.1241C2.57514 6.37736 2.38889 6.7555 2.38889 7.15463V11.9497C2.38889 12.686 3.01072 13.283 3.77778 13.283H12.1111C12.8782 13.283 13.5 12.686 13.5 11.9497V7.15463C13.5 6.7555 13.3137 6.37736 12.9924 6.1241L9.26639 3.18745ZM5.7412 2.15692C7.02187 1.14756 8.86702 1.14756 10.1477 2.15692L13.8737 5.09358C14.5164 5.6001 14.8889 6.35637 14.8889 7.15463V11.9497C14.8889 13.4224 13.6452 14.6163 12.1111 14.6163H3.77778C2.24365 14.6163 1 13.4224 1 11.9497V7.15463C1 6.35637 1.37251 5.6001 2.01518 5.09358L5.7412 2.15692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0032 5C8.44283 5 8.79922 5.34593 8.79922 5.77265V8.86326C8.79922 9.28998 8.44283 9.63591 8.0032 9.63591C7.56357 9.63591 7.20718 9.28998 7.20718 8.86326V5.77265C7.20718 5.34593 7.56357 5 8.0032 5ZM7.19922 11.1773C7.19922 10.7506 7.55561 10.4047 7.99524 10.4047H8.0032C8.44283 10.4047 8.79922 10.7506 8.79922 11.1773C8.79922 11.6041 8.44283 11.95 8.0032 11.95H7.99524C7.55561 11.95 7.19922 11.6041 7.19922 11.1773Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingCancel);
export default __webpack_public_path__ + "static/media/booking_cancel.b04f645071a30b303768ec69e4a449c5.svg";
export { ForwardRef as ReactComponent };